export default "__VITE_ASSET__C$E1LI43__"